module.exports = __webpack_public_path__ + "roboto-thinitalic-webfont.8e8ee82efe71561bc07c.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-thinitalic-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-thinitalic-webfont.woff2
// module chunks = styles